<template>
  <form-step stepName="Amount"
    :checked="checked"
    :validated="validated"
    :declined="declined"
    :checkLoading="checkLoading"
    :onSubmit="onSubmit"
    @reset="$emit('reset')"
    @check="$emit('check', true)"
    @edit="$emit('check', false)"
    @nextStep="$emit('next')">
    <template #title>
      What is the value of the invoice you want to protect (net of VAT)?
    </template>

    <template #form>
      <vue-autonumeric class="form-control"
            placeholder="Enter amount in GBP, e.g. 5000"
            :value="value" @input="$emit('input', $event)"
            :options="{digitGroupSeparator:' '}"
            />
    </template>

    <template #billboard>
      <div v-if="!declined">
        <!-- alert success -->
        <div class="row justify-content-center">
          <h1 class=""><icon icon="check-circle" class="text-success"/></h1>
          <h2 class="mb-4 mx-5">Great news! We can protect your invoice</h2>
        </div>
        <!-- explanatory cards deck-->
        <div class="card-deck">
          <help-card :content="cards.invoiceProtection"/>
          <div class="w-100 d-none d-sm-block d-md-none mb-4"><!-- wrap every 2 on sm--></div>
          <help-card :content="cards.onlyValid"/>
        </div>
      </div>
      <div v-else>
        <error-display title="Unfortunately we cannot accept your request." :body="checked.rejection_reason.detail"></error-display>
      </div>
    </template>
  </form-step>
</template>

<script>
import FormStep from '@/components/FormStep'
import VueAutonumeric from 'vue-autonumeric/src/components/VueAutonumeric.vue'
import HelpCard from '@/components/HelpCard'
import protectCards from '@/data/protectCards'
import ErrorDisplay from '@/components/ErrorDisplay'

export default {
  name: 'amount',
  components: {
    FormStep,
    VueAutonumeric,
    HelpCard,
    ErrorDisplay
  },
  props: {
    checked: Object,
    validated: Boolean,
    checkLoading: Boolean,
    onSubmit: Function,
    value: {}
  },
  data: function () {
    return {
      cards: protectCards
    }
  },
  computed: {
    declined: function () { return this.checked ? this.checked.status === 'rejected' : false }
  }
}
</script>
